import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="hero">
      <div className="hero-overlay" />

      <div className="hero-content">
        <h1 className="hero-title">
          Crypto Trading <span>Automation</span>
        </h1>

        <p className="hero-subtitle">
          Multi-timeframe signals, trade setup control, risk-managed execution, and exchange automation
        </p>

        <div className="hero-actions">
          <button className="primary-btn" onClick={() => navigate("/signup")}>
            Get Started
          </button>
          <button className="secondary-btn" onClick={() => navigate("/login")}>
            Login
          </button>
        </div>

      </div>

      
    </section>
  );
};

export default HeroSection;


